import React, { useState } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import OverflowedContent from '@wix/da-shared-react/pkg/OverflowedContent';
import TextRenderer from '@wix/da-shared-react/pkg/TextRenderer';

import Button from '@wix/da-shared-react/pkg/Button';
import DeviantIdViewer from '@wix/da-shared-react/pkg/DaEditorWrapper/Viewer/DeviantId';
import Separator from '@wix/da-shared-react/pkg/Separator';

import Interests from '../Interests';
import s from './CollapsibleBio.scss';
import { PapiEditorText } from '@wix/da-types-papi';

interface Props {
  bio: PapiEditorText;
  interests?: {
    id: number;
    value: string;
  }[];
  isInitiallyExpanded?: boolean;
}

const CollapsibleBio: React.FC<Props> = ({
  bio,
  interests,
  isInitiallyExpanded,
}) => {
  const { t } = useTranslation();
  const [isBioExpanded, setIsBioExpanded] = useState(isInitiallyExpanded);

  return (
    <OverflowedContent maxHeight={360}>
      {isOverflowed => (
        <>
          <div
            className={classnames(
              s['bio'],
              isOverflowed && !isBioExpanded && s['collapsed']
            )}
          >
            <TextRenderer
              textContent={bio}
              legacyTheme={'default'}
              reactViewer={DeviantIdViewer}
            />

            {interests && (
              <>
                <Separator className={s['interests-separator']} />
                <Interests
                  className={classnames(s['no'])}
                  interests={interests}
                />
              </>
            )}
          </div>
          {isOverflowed && (
            <Button
              className={classnames(
                s['expand-or-collapse-button'],
                !isBioExpanded && s['expand']
              )}
              view="b3"
              onClick={() => setIsBioExpanded(!isBioExpanded)}
            >
              {t(isBioExpanded ? 'common.showLess' : 'common.showMore')}
            </Button>
          )}
        </>
      )}
    </OverflowedContent>
  );
};
CollapsibleBio.displayName = 'CollapsibleBio';

export default CollapsibleBio;
